import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const BranchField = ({
    className,
    name = "branch_code",
    label = "Branch",
    ...restProps
}) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.branch}
        label={label}
        {...restProps}
    />
);
